import environment from './base';
const baseApi = 'https://services.judiciary.gov.sg';
const env = environment(baseApi);
const config ={
  ...env,
  isProduction: true,
  isDevelopment: false,
  isUAT: false,
};
export default config